import { QueryStatus } from '@reduxjs/toolkit/query';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { useAppDispatch } from '@verantos-dev/app-state-base';
import { setConceptGroups } from '@verantos-dev/app-state-cohort-builder';

import { useGetConceptGroupsQuery } from './conceptGroupsApiSlice';

export const useConceptGroups = () => {
  const dispatch = useAppDispatch();
  const { projectId } = useParams();

  const [isConceptGroupsLoading, setIsConceptGroupsLoading] = useState(false);

  const {
    data: conceptGroupsResponse,
    error: conceptGroupsError,
    refetch,
    isLoading,
    isFetching,
    isUninitialized,
    status,
  } = useGetConceptGroupsQuery(projectId || '', {
    skip: !projectId,
  });

  // set concept groups in redux
  useEffect(() => {
    if (conceptGroupsResponse) {
      dispatch(setConceptGroups(conceptGroupsResponse.data));
    }
  }, [conceptGroupsResponse, dispatch]);

  // manage refetch loading status
  useEffect(() => {
    if (isUninitialized || isFetching || isLoading) {
      setIsConceptGroupsLoading(true);
    } else if ([QueryStatus.pending, QueryStatus.uninitialized].includes(status)) {
      setIsConceptGroupsLoading(true);
    } else {
      setIsConceptGroupsLoading(false);
    }
  }, [isFetching, isLoading, isUninitialized, status]);

  return {
    conceptGroups: conceptGroupsResponse?.data || [],
    conceptGroupsError,
    refetchConceptGroups: refetch,
    isConceptGroupsLoading,
  };
};
